import React from 'react';
import * as R from 'ramda';
import { CircularProgressbar } from 'react-circular-progressbar';
import money from './../../../assets/images/svg/109-money.svg';
import anticipa from './../../../assets/images/svg/112-person-white.svg';
import facilita from './../../../assets/images/svg/113-funeral.svg';
import serenita from './../../../assets/images/svg/145-customer-service.svg';

export const AjouterDossierHeader = ({account, setAccount, dossierTypeOptions, steps, etablissement}) => {
    if(R.isNil(steps)){
        return '';
    }

    const completedSteps = steps.filter(s => s === true);

    let logo = anticipa;
    if(account.type === dossierTypeOptions.facilita){
        logo = facilita;
    }else if(account.type === dossierTypeOptions.serenita){
        logo = serenita;
    } 
    
    return (
        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-sm">
            <h2 className="sr-only visually-hidden">Status</h2>
            <div className="grid grid-sm-narrow grid-xl-4">
                <div className="block">
                    <svg style={{ height: 0, position: 'absolute' }}>
                        <defs>
                            <linearGradient id={"idCSS"} gradientTransform={`rotate(${90})`}>
                                <stop offset="0%" stopColor={"#00b33c"} />
                                <stop offset="100%" stopColor={"#66ccff"} />
                            </linearGradient>
                        </defs>
                    </svg>
                    <div className="media">
                        <div className="media-progress mr-3">
                            <CircularProgressbar value={R.isEmpty(completedSteps) ? 0 : completedSteps.length / steps.length} minValue={0} maxValue={1} background={true} text={completedSteps.length.toString()} />
                        </div>
                        <div className="media-body my-auto text-truncate">
                            <h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Actions</h3>
                            <p className="h3 text-dark font-weight-bolder lh-solid mb-0">{steps.filter(s => !s).length} à réaliser</p>
                        </div>
                    </div>
                </div>
                <div className="block">
                    <div className="media">
                        <div className="media-progress mr-3">
                            <div className={"rounded-max flex-column mr-3 rounded-progress text-center" + (account.type == dossierTypeOptions.anticipa ? " bg-gradient-primary" : " bg-dim")}>
                                <img className="img-fluid m-auto" src={logo} alt={account.type} />
                            </div>
                        </div>
                        <div className="media-body my-auto text-truncate">
                            <h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Type</h3>
                            <p className="h3 text-dark font-weight-bolder lh-solid mb-0">{account.type}</p>
                        </div>
                    </div>
                </div>
                <div className="block">
                    <div className="media">
                        <div className="media-progress mr-3">
                            <div className="rounded-max bg-dim flex-column mr-3 rounded-progress text-center">
                            <img className="img-fluid m-auto" src={money} alt="money" />
                            </div>
                        </div>
                        <div className="media-body my-auto text-truncate">
                            <h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Paiement</h3>
                            <p className="h3 text-dark font-weight-bolder lh-solid mb-0">
                                {
                                    account.billedByPartner === true ?
                                        "En interne"
                                    :
                                    account.billedByPartner === false ?
                                        "Par le client en direct"
                                    :
                                        "-"
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}